import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Provide a raw fetch (for SSE) that also carries credentials.
export function apiFetch(path, options = {}) {
  const url = path.startsWith("http") ? path : `${API_BASE}${path}`;
  return fetch(url, {
    credentials: "include",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
}

// Coerce an Axios error's response body into a plain, human-readable string
// suitable for toasts. Pydantic 422 responses put an ARRAY of validation-error
// objects in `detail`, which crashes React when passed through as JSX children.
// Everywhere in the app that renders `err.response?.data?.detail` via toast MUST
// route the value through this helper. Never returns an object.
export function errText(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d)) {
    // Pydantic validation error list: pick the first item's msg if present.
    const first = d.find((x) => x && typeof x === "object" && typeof x.msg === "string");
    if (first?.msg) return first.msg;
  }
  if (typeof err?.message === "string" && err.message && err.message !== "Network Error") return err.message;
  return fallback;
}

export default api;
